import axios from 'axios';
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const techSpecializedApiUrl = `${baseApiUrl}/api/TechSpecialized`;

export async function getTechSpecialized(orderBy) {
    return await httpRequest(fetchTechSpecialized.bind(this, orderBy));
}

async function fetchTechSpecialized(orderBy) {
    let config = getHttpHeaders();
    return await axios.get(`${techSpecializedApiUrl}?orderBy=${orderBy}`, config);
}

export async function addTechSpecialized(newTech) {
  return await httpRequest(postTechSpecialized.bind(this, newTech));
}

async function postTechSpecialized(newTech) {
  let config = getHttpHeaders();
  return await axios.post(`${techSpecializedApiUrl}`, newTech, config);
}

export async function updateTechSpecialized(id, updatedTech) {
  return await httpRequest(putTechSpecialized.bind(this, updatedTech, id));
}

async function putTechSpecialized(updatedTech, id) {
  let config = getHttpHeaders();
  return await axios.put(`${techSpecializedApiUrl}`, { ...updatedTech, id }, config);
}

export async function deleteTechSpecialized(id) {
    return await httpRequest(fetchDeleteTechSpecialized.bind(this, id));
  }
  
async function fetchDeleteTechSpecialized(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${techSpecializedApiUrl}/${id}`, config);
}